
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { SettlementModel } from './Entities.GormCrm.Settlement';
import { Model, ModelProperty } from 'models/Model';


export class SettlementProductPlanModel extends Model<SettlementProductPlanModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'productPlanId', type: 'string' },
		{ name: 'settlementId', type: 'string' },
		{ name: 'amount', type: 'number' },
		{ name: 'endDate', type: 'Date' },
		{ name: 'productPlan', type: 'ProductPlanModel', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'settlement', type: 'SettlementModel', isHidden: true, isObject: true, new: () => { return new SettlementModel }, properties: () => { return SettlementModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public productPlanId?: string;
	public settlementId?: string;
	public amount: number;
	public endDate?: Date;
	public productPlan?: ProductPlanModel;
	public settlement?: SettlementModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.productPlanId = undefined;
		this.settlementId = undefined;
		this.amount = 0;
		this.endDate = undefined;
		this.productPlan = undefined;
		this.settlement = undefined;
		
	}
	getProperties(){
		return SettlementProductPlanModel.classProperties;
	}
}

